import { PlusIcon } from '@/components/icons/plus';
import { MoreButton } from '@/components/more-button/more-button';
import { styled } from '@/stitches.config';
import { useMemo, useState } from 'react';
import { DesktopCardList } from './desktop-card-list';
import { Box } from '@/components/box/box';
import { WorkSubsection } from '@/lib/schemas/work-subsection';

interface DesktopOverviewProps {
  subsection: WorkSubsection;
  canAnimate: boolean;
}

const Plus = styled(PlusIcon, {
  marginLeft: '$2',
});

export function DesktopOverview({
  subsection,
  canAnimate,
}: DesktopOverviewProps) {
  const { hasLimit, limitNumber } = subsection;
  const [limit, setLimit] = useState(
    hasLimit && limitNumber ? limitNumber : 999
  );

  const cards = useMemo(() => {
    if (subsection.projects.length > limit) {
      return subsection.projects.slice(0, limit);
    }
    return subsection.projects;
  }, [subsection.projects, limit]);

  return (
    <Box
      css={{
        display: 'none',
        '@bp4': {
          display: 'contents',
        },
      }}
    >
      <DesktopCardList cards={cards} canAnimate={canAnimate} />

      {limit < subsection.projects.length && (
        <MoreButton handleClick={() => setLimit(999)}>
          <span>More</span>
          <Plus width={10} height={10} />
        </MoreButton>
      )}
    </Box>
  );
}
